import { apis } from 'ui-common';
import * as _ from 'lodash';

import { getWindow } from 'login-utils/globalWrappers';

const sendCreateChangeEvent = (prevState: string | null, nextState: string) =>
  apis.pixelAPI.createStateChange({
    event: {
      prevState,
      nextState,
    },
    labels: {
      app: getWindow().APP_NAME,
    },
  });

export const pixelLog = ({ routes }, store) => {
  const lastRouteName = _.get(store.getState().global.lastAttemptedRoute, 'name');
  const { name } = _.last<RouteState>(routes)!;
  return sendCreateChangeEvent(lastRouteName, name);
};

export const manuallyLogStateChange = (store, nextState: string) => {
  const lastRouteName = _.get(store.getState().global.lastAttemptedRoute, 'name');
  return sendCreateChangeEvent(lastRouteName, nextState);
};

export const sendClickEvent = async event => {
  apis.pixelAPI.createClick({
    event,
    labels: {
      app: getWindow().APP_NAME,
    },
  });
};
